<template>
  <TitleWrapper
    :filter-option="true"
    title="STAFF"
    tooltip-title="STAFF"
    :display-breadcrumb="true"
    :displayed-column-options="csvFilterOptions"
    :already-selected-displayed-column="filtersPayload.displayedColumns"
    :count="filtersCount"
    @cancel="cancelHanlder"
    @applyFilter="emitFiltersPayload($event, invalid)"
    @clear="clearFilters"
  >
    <template v-slot:filterItems>
      <InputFieldWrapper layout-mode="true">
        <UiInput
          v-model.trim="filtersPayload.first_name"
          title="First Name"
          type="text"
          placeholder="SEARCH_BY_FNAME"
          rules="alpha_spaces"
          :filter="FILTERS_LIST.FIRST_NAME"
          @emitQuery="updateQuery"
        ></UiInput>
        <UiInput
          v-model.trim="filtersPayload.last_name"
          title="Last Name"
          type="text"
          placeholder="SEARCH_BY_LNAME"
          rules="alpha_spaces"
          :filter="FILTERS_LIST.LAST_NAME"
          @emitQuery="updateQuery"
        ></UiInput>
        <UiInput
          v-model.trim="filtersPayload.phone"
          title="Phone Number"
          placeholder="Phone Number"
          :filter="FILTERS_LIST.PHONE"
          @emitQuery="updateQuery"
        />
        <UiInput
          v-model.trim="filtersPayload.email"
          title="Email"
          placeholder="Email"
          :filter="FILTERS_LIST.EMAIL"
          @emitQuery="updateQuery"
        />
        <UiSingleSelect
          v-model.trim="filtersPayload.gender"
          title="Gender"
          :options="GENDERS"
          input-color="bg-white"
          label="title"
          reduce="value"
          :filter="FILTERS_LIST.GENDER"
          @emitQuery="updateQuery"
        />
        <UiDatePicker
          v-model.trim="filtersPayload.join_date"
          title="JOINING_DATE"
          placeholder="JOINING_DATE"
          :filter="FILTERS_LIST.JOIN_DATE"
          picker="date"
          @emitQuery="updateQuery"
        />
        <UiDatePicker
          v-model="filtersPayload.date_of_birth_after"
          title="DOB_GT"
          :filter="FILTERS_LIST.DATE_OF_BIRTH_GREATER_THAN"
          @change="birthDateAfter"
          @emitQuery="updateQuery"
        />
        <UiDatePicker
          v-model="filtersPayload.date_of_birth_before"
          title="DOB_LT"
          :filter="FILTERS_LIST.DATE_OF_BIRTH_LESS_THAN"
          @change="birthDateBefore"
          @emitQuery="updateQuery"
        />
        <UiInput
          v-model.trim="filtersPayload.address"
          title="Address"
          type="text"
          placeholder="Address"
          :filter="FILTERS_LIST.ADDRESS"
          @emitQuery="updateQuery"
        />
        <UiInput
          v-if="isReligion"
          v-model.trim="filtersPayload.religion"
          title="Religion"
          type="text"
          placeholder="Religion"
          :filter="FILTERS_LIST.RELIGION"
          @emitQuery="updateQuery"
        />
        <UiSingleSelect
          v-model.trim="filtersPayload.login_enabled"
          title="STATUS"
          :options="LOGIN_ENABLED_STATUSES"
          input-color="bg-white"
          label="title"
          reduce="value"
          :filter="FILTERS_LIST.LOGIN_ENABLED_STATUS"
          @emitQuery="updateQuery"
        />
        <UiSingleSelect
          v-model="filtersPayload.major_role"
          title="Major Role"
          :options="roles"
          input-color="bg-white"
          label="title"
          :filter="majorRoleFilter"
          @emitQuery="updateQuery"
        />
      </InputFieldWrapper>
    </template>
  </TitleWrapper>
</template>

<script>
import UiInput from '@components/UiElements/UiInputBox.vue'
import UiSingleSelect from '@/src/components/UiElements/UiSingleSelect.vue'
import TitleWrapper from '@components/TitleWrapper.vue'
import { USER_CONSTANTS } from '@src/constants/general-constants'
import {
  formatObjectKeyValues,
  setObjectValuesToEmpty,
  removeEmptyKeysFromObject,
  objectDeepCopy,
  getCountFromObject,
} from '@utils/generalUtil'
import FILTER_KEYS, { FILTERS_LIST } from '@src/constants/filter-constants.js'
import { fullName } from '@src/utils/settings/tenant-user.util.js'
import fileMixins from '@/src/mixins/file-mixins'
import filterMixins from '@/src/mixins/filter-mixins.js'
import UiDatePicker from '@components/UiElements/UiDatePicker.vue'
import { mapState, mapActions } from 'vuex'
import state from '@/src/state/modules/exams/state'
import InputFieldWrapper from '@/src/components/UiElements/InputFieldWrapper.vue'

export default {
  name: 'TeacherFilters',
  components: {
    UiInput,
    UiSingleSelect,
    TitleWrapper,
    UiDatePicker,
    InputFieldWrapper,
  },
  mixins: [fileMixins, filterMixins],
  props: {
    csvFilterOptions: {
      type: Array,
      default: () => [],
    },
    alreadySelectedDisplayedColumns: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      FILTER_KEYS,
      FILTERS_LIST,
      majorRoleFilter: {
        option: FILTER_KEYS.EQUAL,
        key: 'major_role',
      },
      $where: {},
      queries: {},
      filtersCount: 0,
      forceRender: 0,
      appliedQueries: {},
      dashboard: 'dashboard',
      roles: [
        this.$t(`dashboard.RESPONSIBILITY1`),
        this.$t(`dashboard.RESPONSIBILITY2`),
        this.$t(`dashboard.RESPONSIBILITY3`),
        this.$t(`dashboard.RESPONSIBILITY4`),
        this.$t(`dashboard.RESPONSIBILITY5`),
        this.$t(`dashboard.OTHER`),
      ],
      GENDERS: USER_CONSTANTS.GENDERS,
      LOGIN_ENABLED_STATUSES: USER_CONSTANTS.LOGIN_ENABLED_STATUSES,
      filtersPayload: {
        login_enabled: '',
        major_role: '',
        first_name: '',
        last_name: '',
        gender: '',
        email: '',
        phone: '',
        join_date: '',
        date_of_birth_before: '',
        date_of_birth_after: '',
        address: '',
        religion: '',
        displayedColumns: [],
      },
    }
  },
  computed: {
    ...mapState({
      isReligion: (state) => state.inputFields.isReligion,
      currentSectionScope: (state) => state.layout.currentSectionScope.id,
      campus: (state) => state.layout.currentCampusScope || null,
    }),
  },
  watch: {
    campus: {
      handler() {
        this.clearFilters()
      },
    },

    currentSectionScope: {
      handler() {
        this.clearFilters()
      },
    },
  },
  created() {
    this.updateDisplayedColumnList()
  },
  methods: {
    getFiltersCount() {
      return getCountFromObject(this.filtersPayload, 'displayedColumns', 'boolean')
    },
  },
}
</script>
